
  // export interface ToolType {
  //   display: string
  // }
  export interface UIStatusUpdate {
    id: number
    currentDisplay: string
    bezierDisplayValue?: number[]
    initializationTime: number
  }
  
  export interface configSettingsUpdate {
    keyframeCollisionBehavior: string,
    keyframeWriteAtTimeBehavior: string
  }

  export interface ContextState {
    UIStatus: UIStatusUpdate
    configSettings: configSettingsUpdate
    synergy: synergyVals
    persistUI: persistUIUpdate
    keysHeld: keysHeld
  }

  export interface keysHeld {
    shift: boolean
    alt: boolean
    ctrl: boolean
  }

  export interface synergyVals {
      easeIn: string
      easeOut: string
      getIn: boolean
      getOut: boolean
      display: boolean
  }

  export enum UITools {
    bezier = 'bezier',
    elastic = 'elastic',
    bounce = 'bounce',
    distribute = 'distribute',
    synergy = 'synergy',
  }

  export interface persistUIUpdate {
    presetPanelLocked: boolean
  }
  
  export type Action =
    | { type: 'UIStatusUpdate', payload: UIStatusUpdate }
    | { type: 'configSettings', payload: configSettingsUpdate }
    | { type: 'synergy', payload: synergyVals }
    | { type: 'delete', payload: number | string }
    | { type: 'persistUI', payload: persistUIUpdate }
    | { type: 'keysHeld', payload: keysHeld }